export enum TransferType {
  blindTransfer = 'blindTransfer',
  safeTransfer = 'safeTransfer',
  consultativeTransfer = 'consultativeTransfer',
}
